import { map } from "ramda";
import { State } from "../state";

type SelectorObj<T> = { [K in keyof T]: (s: State) => T[K] };
const selectorsToProps = <T>(obj: SelectorObj<T>) => {
  return (state: State) =>
    map<SelectorObj<T>, T>(selector => selector(state), obj);
};

export default selectorsToProps;



// WEBPACK FOOTER //
// ./src/utils/selectorsToProps.ts